module.exports = __webpack_public_path__ + "static/media/Clock.1d697462.svg";